import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
  hideImageOnMobile: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'QualifyStep',
})(({ brandColors, spacing, breakpoints, typography, aspectRatio }, props) => ({
  inputGroup: {
    margin: `${spacing(2)} 0`,
  },
  inputContainer: {
    maxWidth: typography.pxToRem(328),
    width: '100%',
    marginBottom: spacing(1),
  },
  radioContainer: {
    width: typography.pxToRem(328),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  landerImage: {
    borderRadius: typography.pxToRem(16),
    width: '100%',
    objectFit: 'cover',
    aspectRatio: aspectRatio['4/3'],
    height: 'auto',
  },
  button: {
    minWidth: typography.pxToRem(142),
    padding: `${typography.pxToRem(18)} ${spacing(1)}`,
    marginBottom: spacing(3),
    [breakpoints.up('lg')]: {
      margin: 0,
    },
  },
  heading: {
    maxWidth: typography.pxToRem(390),
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
    [breakpoints.up('sm')]: {
      maxWidth: typography.pxToRem(539),
    },
    [breakpoints.up('lg')]: {
      maxWidth: typography.pxToRem(627),
    },
    [breakpoints.up('xl')]: {
      maxWidth: typography.pxToRem(840),
    },
  },
  subheading: {
    margin: `${spacing(1)} 0 ${spacing(2)} 0`,
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
    maxWidth: typography.pxToRem(390),
    [breakpoints.up('md')]: {
      maxWidth: typography.pxToRem(539),
    },
    [breakpoints.up('lg')]: {
      maxWidth: typography.pxToRem(627),
    },
    [breakpoints.up('xl')]: {
      maxWidth: typography.pxToRem(840),
    },
  },
  visible: {
    display: 'flex',
  },
  hidden: {
    display: 'none',
  },
  step: {
    padding: `${spacing(0)} 0 ${spacing(-1)} 0`,
    textTransform: 'uppercase',
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
  },
  layout: {
    flexDirection: 'column',
    [breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  reverseLayout: {
    flexDirection: 'column-reverse',
    [breakpoints.up('md')]: {
      flexDirection: 'row-reverse',
    },
  },
  reverseContent: {
    [breakpoints.up('md')]: {
      paddingLeft: spacing(3),
    },
  },
  hideImageOnMobile: {
    [breakpoints.down('md')]: {
      display: props.hideImageOnMobile ? 'none' : 'flex',
    },
  },
}));

export default useStyles;
